import axios from "axios";
const baseURL = process.env.REACT_APP_API_URL;

export const get_all_permissions = async () => {
    let response = await axios.get(baseURL + '/permissions')
    return response.data
}
// Add New Role
export const create_role = async (name: string,status:number, permissions: string[]) => {
    const values = {
        name,
        status,
        permissions,
    }
    let response = await axios.post(baseURL + '/roles', values)
    return response.data
}
// Get All Roles
export const get_all_roles = async () => {
    let response = await axios.get(baseURL + "/roles");
    return response.data;
}
// Get Role By ID
export const get_role_by_id = async (id: number) => {
    let response = await axios.get(baseURL + "/roles/" + id);
    return response.data;
}
export const get_active_roles = async () => {
    let response = await axios.get(baseURL + "/active-roles");
    return response.data;
}
// Delete Role
export const delete_role = async (id: number) => {
    let response = await axios.delete(baseURL + "/roles/" + id);
    return response.data;
}
// Edit Role
export const edit_role = async (id: number, name: string, permissions: string[], status: number) => {
    const values = {
        name,
        permissions,
        status, // Include status in the payload
    }
    let response = await axios.patch(`${baseURL}/roles/${id}`, values)
    return response.data
};
export const get_all_roles_logs = async () => {
    let response = await axios.get(baseURL + "/all-roles-logs");
    return response.data;
}
export const get_role_logs = async (id: number) => {
    let response = await axios.get(baseURL + "/single-role-log/" + id);
    return response.data;
  };